<footer class="site-footer" [attr.aria-label]="'footer.regionLabel' | translate">
  <div class="site-footer__brand">
    <img class="site-footer__logo"
      [src]="brand.logoOnDark"
      [alt]="brand.name" width="280" height="72" loading="lazy" />
    <p class="site-footer__support">
      <span class="material-symbols-outlined" aria-hidden="true">support_agent</span>
      {{ 'footer.links.contact' | translate }}
    </p>
  </div>

  <div class="site-footer__section site-footer__payments">
    <section aria-labelledby="footer-payments-heading">
      <h2 id="footer-payments-heading" class="site-footer__heading">{{ 'footer.sections.payments' | translate }}</h2>
      <ul class="site-footer__payment-brands" [attr.aria-label]="'footer.payments.cards' | translate">
        <li class="site-footer__method site-footer__credit-card">
          <span class="material-symbols-outlined" aria-hidden="true">credit_card</span>
          <span>{{ 'footer.payments.creditCard' | translate }}</span>
        </li>
        @for (payment of paymentBrands; track payment.asset) {
          <li class="site-footer__payment-brand" [attr.data-brand]="payment.asset">
            <img class="site-footer__asset" [alt]="payment.label"
              [src]="assetPath + '/' + payment.asset + '.svg'" width="100" height="38" loading="lazy" />
          </li>
        }
      </ul>
      <ul class="site-footer__methods site-footer__deposit-methods" [attr.aria-label]="'footer.payments.other' | translate">
        @for (method of paymentMethods; track method.labelKey) {
          <li class="site-footer__method">
            <span class="material-symbols-outlined" aria-hidden="true">{{ method.icon }}</span>
            <span>{{ method.labelKey | translate }}</span>
          </li>
        }
      </ul>
    </section>
    <section class="site-footer__payouts" aria-labelledby="footer-payouts-heading">
      <h2 id="footer-payouts-heading" class="site-footer__heading">{{ 'footer.sections.payouts' | translate }}</h2>
      <ul class="site-footer__methods">
        @for (method of payoutMethods; track method.labelKey) {
          <li class="site-footer__method">
            <span class="material-symbols-outlined" aria-hidden="true">{{ method.icon }}</span>
            <span>{{ method.labelKey | translate }}</span>
          </li>
        }
      </ul>
    </section>
  </div>

  <div class="site-footer__section site-footer__trust">
    <ul class="site-footer__social" [attr.aria-label]="'footer.socialMedia' | translate">
      @for (social of socialBrands; track social.asset) {
        <li>
          <img class="site-footer__asset" [alt]="social.label"
            [src]="assetPath + '/' + social.asset + '.svg'" width="24" height="24" loading="lazy" />
        </li>
      }
    </ul>
    <div class="site-footer__responsibility">
      <span class="site-footer__age-badge">{{ 'footer.ageBadge' | translate }}</span>
      <p>
        {{ 'footer.disclaimerLead' | translate }}{{ 'footer.inlineLinkLabel' | translate }}{{ 'footer.disclaimerLeadSuffix' | translate }}
      </p>
    </div>
  </div>

  <div class="site-footer__section site-footer__navigation">
    <div class="site-footer__columns">
      @for (column of columns; track column.id) {
        <section class="site-footer__column" [class]="'site-footer__column--' + column.id">
          <h2 [id]="'footer-' + column.id + '-heading'" class="site-footer__heading">{{ column.headingKey | translate }}</h2>
          <ul class="site-footer__list">
            @for (item of column.items; track item.labelKey) {
              <li>
                @if (item.sportId !== undefined) {
                  <button
                    class="site-footer__link site-footer__sport"
                    type="button"
                    [disabled]="!isSportAvailable(item.sportId)"
                    (click)="selectSport(item.sportId)"
                  >
                    {{ item.labelKey | translate }}
                  </button>
                } @else if (item.action === 'registration') {
                  <button class="site-footer__link" type="button" (click)="registration.openRegistration()">
                    {{ item.labelKey | translate }}
                  </button>
                } @else {
                  <span class="site-footer__label">{{ item.labelKey | translate: { brand: brand.name } }}</span>
                }
              </li>
            }
          </ul>
        </section>
      }
    </div>
    <p class="site-footer__license">{{ 'footer.regulation' | translate }}</p>
    <p class="site-footer__copyright">&copy; {{ currentYear }} {{ brand.name }}. {{ 'footer.rightsReserved' | translate }}</p>
  </div>
</footer>
